import React, { useState, useEffect } from "react";
import Style from "../style/loginpopup.module.scss";

const LoginPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    const hasShown = sessionStorage.getItem("hasShownLoginPopup");
    if (!hasShown) {
      const timer = setTimeout(() => {
        setIsOpen(true);
        sessionStorage.setItem("hasShownLoginPopup", "true");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => setIsOpen(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Login Submitted", { email, password });
    handleClose();
  };

  return (
    <>
      {isOpen && (
        <div className={Style.popupOverlay}>
          <div className={Style.popupContainer}>
            <button className={Style.closeBtn} onClick={handleClose}>
              &times;
            </button>
            <h2 className={Style.popupTitle}>Welcome Back 👋</h2>
            <p className={Style.subtitle}>Please login to continue</p>
            <form onSubmit={handleSubmit}>
              <div className={Style.inputGroup}>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email"
                  required
                  className={Style.input}
                />
              </div>
              <div className={Style.inputGroup}>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  required
                  className={Style.input}
                />
              </div>
              <button type="submit" className={Style.submitBtn}>
                🚀 Login
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default LoginPopup;
